import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';
import { setCurrentEvent, DAY_EVENT_HEIGHT } from '~/Redux/Modules/Events';
import AllDayEvents from '~/Components/Pages/Calendar/WeekView/AllDayEvents';
import MealPrep from '~/Containers/Global/MealPrep/MealPrep';
import CounterColumn from '~/Components/Pages/Calendar/WeekView/TimeGrid/CounterColumn';
import NoScrollBar from '~/Components/Global/NoScrollBar/NoScrollBar';
import { generateWeek } from '~/Context/Global';
import { WEEK_VIEW } from '~/Config/CalendarViews';
import { weekEventIndexes } from '~/Context/Event';
import WeekDay from '~/Containers/Pages/Calendar/WeekView/WeekDay';
import moment from '~/Providers/Moment';
import { setDayType } from '~/Redux/Modules/DateRange';
import { MUST_DO } from '~/Config/Checklists';
import { TaskList } from '~/Components/Pages/Calendar/Tasks';
import { humanDateFormats } from '~/Redux/Modules/UserOptions';
import { DATE_FORMAT } from '~/Redux/Constants';
import { DrawingProvider } from '~/Components/Global/Drawing/DrawingProvider';
import { filterEventsByCalendarDisplay } from '~/Redux/Modules/Events/selectors';

export class Week extends Component {
  constructor(props) {
    super(props);

    this.headers = {
      en: [
        { key: 0, tablet: 'Sun', mobile: 'Su' },
        { key: 1, tablet: 'Mon', mobile: 'M' },
        { key: 2, tablet: 'Tue', mobile: 'T' },
        { key: 3, tablet: 'Wed', mobile: 'W' },
        { key: 4, tablet: 'Thu', mobile: 'Th' },
        { key: 5, tablet: 'Fri', mobile: 'F' },
        { key: 6, tablet: 'Sat', mobile: 'S' },
      ],
      'en-gb': [
        { key: 0, tablet: 'Mon', mobile: 'M' },
        { key: 1, tablet: 'Tue', mobile: 'T' },
        { key: 2, tablet: 'Wed', mobile: 'W' },
        { key: 3, tablet: 'Thu', mobile: 'Th' },
        { key: 4, tablet: 'Fri', mobile: 'F' },
        { key: 5, tablet: 'Sat', mobile: 'S' },
        { key: 6, tablet: 'Sun', mobile: 'Su' },
      ],
    };

    this.state = {
      eventIndexes: [],
      firstLoad: true,
      isInCollapsibleSection: true,
    };
  }

  generateHeaders = (days, week) =>
    this.headers[moment.locale()].map((header, key) => {
      const { humanDateFormats } = this.props;
      if (days[key]) {
        return [
          <div
            key="a"
            onClick={() => this.props.openDayView(week[key])}
            className={`flex-1 tablet ${
              week[key].isSame(moment(), 'day') ? 'current-' : ''
            }day-heading`}
          >
            {`${header.tablet}, ${week[key].format(humanDateFormats['MMM D'])}`}
          </div>,
          <div
            key="b"
            onClick={() => this.props.openDayView(week[key])}
            className={`flex-1 mobile ${
              week[key].isSame(moment(), 'day') ? 'current-' : ''
            }day-heading`}
          >
            <span className="day">{header.mobile}</span>
            <span className="date">{week[key].format('D')}</span>
          </div>,
        ];
      }
    });

  generateTodos = (days, week) => {
    return week.map((day, index) => {
      if (days[index]) {
        return (
          <div
            key={index}
            className={`week-todo flex-1 ${day.isSame(moment(), 'day') ? 'current-day' : ''}`}
          >
            <TaskList
              date={day}
              type={MUST_DO}
              isInCollapsibleSection={this.state.isInCollapsibleSection}
              isTasksSectionCollapsed={this.props.isTasksSectionCollapsed}
              header="PRIORITY"
              disableTaskWrapping
            />
          </div>
        );
      }
    });
  };

  generateMealPreps = (days, week) => {
    return week.map((day, index) => {
      if (days[index]) {
        return (
          <div
            key={index}
            className={`week-meal flex-1 ${day.isSame(moment(), 'day') ? 'current-day' : ''}`}
          >
            <MealPrep date={day} isMealsSectionCollapsed={this.props.isMealsSectionCollapsed} />
          </div>
        );
      }
    });
  };

  componentWillReceiveProps = nextProps => {
    if (
      Object.keys(nextProps.events).length &&
      (this.state.firstLoad ||
        !isEqual(nextProps.events, this.props.events) ||
        !nextProps.start.isSame(this.props.start) ||
        nextProps.useMondayStart != this.props.useMondayStart)
    ) {
      this.setState({
        eventIndexes: weekEventIndexes(nextProps.events, nextProps.start),
      });
    }
    this.setState({ firstLoad: false });
  };

  render() {
    const {
      days,
      showTimeGrid,
      time,
      showScrollOnHover,
      expanded,
      toggleExpand,
      isTasksSectionCollapsed,
      isMealsSectionCollapsed,
      handleMealsSectionClick,
      handleTasksSectionClick,
      isLeftSide,
    } = this.props;
    const week = generateWeek(time);
    const headerHeight =
      (expanded ? this.state.eventIndexes.length : Math.min(this.state.eventIndexes.length, 3)) *
        (DAY_EVENT_HEIGHT + 2) +
      (expanded ? this.state.eventIndexes.length + 1 : Math.min(this.state.eventIndexes.length, 3));

    const startDate = week.filter((day, key) => days[key])[0];
    const endDate = week.filter((day, key) => days[key]).reverse()[0];

    return [
      <div key="a" className="flex-row week-day-header">
        {this.generateHeaders(days, week)}
      </div>,
      <div
        key="b"
        className={`flex-row week-day-header all-day-wrapper ${expanded ? 'expanded' : ''}`}
        style={{ height: headerHeight, flex: `0 0 ${headerHeight / 10}rem` }}
      >
        <AllDayEvents
          eventIndexes={this.state.eventIndexes}
          days={days}
          week={week}
          expanded={expanded}
          toggleExpand={toggleExpand}
        />
        {showTimeGrid && expanded && (
          <div
            className="close-more"
            key="aa"
            onClick={e => {
              e.preventDefault();
              toggleExpand(false);
            }}
          />
        )}
      </div>,
      <div key="c" className="week-wrapper">
        <NoScrollBar showScrollOnHover={showScrollOnHover}>
          <div className="week">
            <DrawingProvider
              views={[WEEK_VIEW]}
              startDate={startDate.format(DATE_FORMAT)}
              endDate={endDate.format(DATE_FORMAT)}
            >
              {showTimeGrid && (
                <div className="counter">
                  <CounterColumn />
                </div>
              )}
              {week.map((day, key) => {
                if (days[key]) {
                  return (
                    <WeekDay
                      stickerView={WEEK_VIEW}
                      key={key}
                      day={day}
                      onClick={this.props.onDayClick}
                    />
                  );
                }
              })}
            </DrawingProvider>
          </div>
        </NoScrollBar>
      </div>,
      <div className="both-collapsible-sections-wrapper">
        {isLeftSide && (
          <>
            <div className="weekview-tasks-button-wrapper">
              <button
                onClick={() => {
                  handleTasksSectionClick();
                }}
                className={
                  isTasksSectionCollapsed ? 'collapsed-weekview-btn' : 'uncollapsed-weekview-btn'
                }
              />
            </div>
            <div
              className={
                isMealsSectionCollapsed
                  ? 'weekview-meals-button-wrapper'
                  : 'weekview-meals-button-wrapper-expanded'
              }
            >
              <button
                onClick={() => {
                  handleMealsSectionClick();
                }}
                className={
                  isMealsSectionCollapsed ? 'collapsed-weekview-btn' : 'uncollapsed-weekview-btn'
                }
              />
            </div>
          </>
        )}
        <div
          key="d"
          className="flex-row week-todo-wrapper"
          style={{ height: isTasksSectionCollapsed ? 25 : 145 }}
          onClick={isTasksSectionCollapsed ? handleTasksSectionClick : null}
        >
          {this.generateTodos(days, week)}
        </div>
        <div
          key="e"
          className="flex-row week-meal-preps"
          style={{ height: isMealsSectionCollapsed ? 25 : 101 }}
          onClick={isMealsSectionCollapsed ? handleMealsSectionClick : null}
        >
          {this.generateMealPreps(days, week)}
        </div>
      </div>,
    ];
  }
}

Week.propTypes = {
  days: propTypes.oneOfType([propTypes.object, propTypes.array]),
  onDayClick: propTypes.func,
  time: propTypes.object,
  showTimeGrid: propTypes.bool,
  showScrollOnHover: propTypes.bool,
  events: propTypes.object,
  start: propTypes.object,
  expanded: propTypes.bool,
  toggleExpand: propTypes.func,
  useMondayStart: propTypes.bool,
  openDayView: propTypes.func,
  humanDateFormats: propTypes.object.isRequired,
  isTasksSectionCollapsed: propTypes.bool,
  isMealsSectionCollapsed: propTypes.bool,
  handleTasksSectionClick: propTypes.func,
  handleMealsSectionClick: propTypes.func,
  isLeftSide: propTypes.bool,
};

Week.defaultProps = {
  showTimeGrid: false,
};

const mapStateToProps = ({ Events, Checklists, DateRange, UserOptions, CalendarAccounts }) => {
  const calendarDisplayOptions = {
    includeMonthView: true,
    includeWeekView: false,
    includeDayView: true,
  };
  const calendarMap = CalendarAccounts.calendarMap;
  const filteredEvents = filterEventsByCalendarDisplay(
    Events.formattedData,
    calendarDisplayOptions,
    calendarMap
  );
  return {
    start: DateRange.start,
    end: DateRange.end,
    events: filteredEvents,
    todo: Checklists.data,
    useMondayStart: UserOptions.data?.use_monday_start,
    humanDateFormats: humanDateFormats({ UserOptions }),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrentEvent: event => dispatch(setCurrentEvent(event)),
    openDayView: day => dispatch(setDayType(day.clone())),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Week);
